import React from "react";
import { Button, Tooltip } from "antd";
import CatIcon from "../../../assets/images/cat-icon.svg";
import { Colors } from "../../../theme";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import DashboardCard from "./Card";

export default function ProductCard({ allowed }) {
  const history = useHistory();
  const AllProductsCard = styled.div`
    .card {
      margin-right: 1rem;
      min-height: 25em;
      margin-top: 0.5rem;
      padding: 1rem;
      border-radius: 0.5rem;
      &:hover {
        background: ${allowed && "#f5fcfb"};
        cursor: ${allowed && "pointer"};
      }
      @media (max-width: 400px) {
        padding: 0rem;
      }
    }
  `;

  const handleClick = () => {
    if (allowed) {
      history.push("/master-catalogue");
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.MASTER_CATALOGUE,
        GA.DESCRIPTION.MASTER_CATALOGUE_CARD
      );
    }
  };
  return (
    <Tooltip
      trigger="hover"
      // visible={!allowed}
      title={!allowed && "You need to be a contributor to create a collection"}
    >
      <AllProductsCard>
        <DashboardCard
          allowed={allowed}
          onClick={handleClick}
          icon={
            <img src={CatIcon} alt="catlougue" height={"64px"} width={"64px"} />
          }
          title="All Products"
          subTitle="You can add new products and edit or delete existing
          products"
          cta={
            <Button
              size="large"
              style={{
                padding: 0,
              }}
              type="link"
              disabled={!allowed}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.MASTER_CATALOGUE,
                  GA.DESCRIPTION.MASTER_CATALOGUE_BUTTON
                );
              }}
            >
              See all products
            </Button>
          }
        />
      </AllProductsCard>
    </Tooltip>
  );
}
